import { defineStore } from 'pinia';

import type { LinkedIntegration } from '@stuut/api/models';

import { stuut } from '@/api';

interface State {
  linkedIntegrations: LinkedIntegration[];
}

export const useLinkedIntegrations = defineStore('linked-integrations', {
  actions: {
    async fetchLinkedIntegrations() {
      return stuut.linkedIntegrations
        .list()
        .then((linkedIntegrations) => {
          this.$patch({ linkedIntegrations });
          return this.linkedIntegrations;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  getters: {
    getById: (state) => {
      return (id: string) =>
        state.linkedIntegrations.find((linkedIntegration) => linkedIntegration.id === id);
    },
  },
  state: (): State => ({
    linkedIntegrations: [],
  }),
});

export default useLinkedIntegrations;
